const Reference_Api = [
  {
    id: 5,
    image: "./image/Reference_image/Chinmoy_Karmoker.jpeg",
    name: "Chinmoy Karmoker",
    designation: "Assistant Manager",
    company: "Multibrand Workshop Ltd",
    address: "Tejgaon Industrial Area, Dhaka 1208",
    desc: "Nasif has shown excellent development skills in building our ERP system. His expertise in React and modern technologies helped deliver scalable, high-performance solutions, while his attention to quality and problem-solving made him a valuable part of our team.",
  },
  {
    id: 4,
    image: "./image/Reference_image/Setu.jpg",
    name: "MD Farukul Islam",
    designation: "Full Stack Developer (Team Lead)",
    company: "TS4U IT",
    address: "Warren, Michigan, United States",
    desc: "Nasif contributed greatly to our frontend projects by developing modern user interfaces, reusable components, and improving application performance. His technical skills, teamwork, and dedication consistently made a positive impact on our development process.",
  },
  {
    id: 3,
    image: "./image/Reference_image/Rana.jpg",
    name: "Mahmudul Islam Rana",
    designation: "General Secretary",
    company: "Bangladesh Taekwondo Federation",
    address: "National Sports Council, Paltan, Dhaka",
    desc: "As a technical lead, Nasif revolutionized our sports federation's digital presence. His expertise in technology and strategic thinking enhanced our operations and engagement with athletes and fans. His contributions were invaluable to our success.",
  },
  {
    id: 2,
    image: "./image/Reference_image/Anica.jpeg",
    name: "Gazi Anica Aslam",
    designation: "Program Officer",
    company: "Youth Against Hunger Bangladesh",
    address: "An International Youth Organization",
    desc: "Nasif's leadership in our youth organization was exceptional. His ability to motivate and guide young members led to numerous successful events and initiatives. His dedication and vision have left a lasting impact on our community.",
  },
  {
    id: 1,
    image: "./image/Reference_image/Abdul_Alim_Bhuiyan.jpg",
    name: "Abdul Alim Bhuiyan",
    designation: "Deputy Director",
    company: "Bangladesh Bureau of Statistics (BBS)",
    address: "Agargaon, Mirpur, Dhaka",
    desc: "Nasif's work with the Bureau of Statistics was outstanding. His technical skills and attention to detail greatly improved our data management and analysis processes. His contributions were critical to the success of our government projects.",
  },
];

export default Reference_Api;
